define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "csi/table/AggregateFrom",
    "csi/xml",
    "./_VersionsMixin"
], function(declare,lang,AggregateFrom,xml,_VersionsMixin) {

    return declare([AggregateFrom, _VersionsMixin], {
        _ignoreNonEligibleProducts: false,

        toWriterRequest: function() {
            return this.inherited(arguments).addParameter("IgnoreNonEligibleProducts", xml.ATTR_BOOLEAN, this._ignoreNonEligibleProducts);
        },

        _onPublishError: function(/*Error*/err) {
            if (err.csiErrorCode.indexOf("CANNOT_CARRYOVER") >= 0) {
                this._promptForCarryover(err.message);
            } else {
                this.inherited(arguments);
            }
        },

        _promptForCarryover: function(/*String*/errorMessage) {
            this.confirmAction({
                message: errorMessage,
                onResponse: lang.hitch(this, this._afterPromptForCarryover)
            });
        },

        _afterPromptForCarryover: function(/*String*/key) {
            if (key == "Y") {
                this._ignoreNonEligibleProducts = true;
                this.setProgress();
                AggregateFrom.prototype.process.call(this);
            } else {
                this.postProcess();
            }
        }
    });
});